/**
 * Send a message to React Native WebView if available.
 *
 * @param {string} type - The type of message
 * @param {object} payload - Additional data to send
 */
export const postMessageToReactNative = (type, payload = {}) => {
    if (globalThis.ReactNativeWebView) {
        globalThis.ReactNativeWebView.postMessage(
            JSON.stringify({ type, ...payload })
        );
    }
};

/**
 * Enable or disable nested scroll in React Native WebView.
 * Used when modals/overlays open or close to allow proper scrolling behavior on Android.
 *
 * @param {boolean} enabled - Whether nested scroll should be enabled
 */
export const setNestedScrollEnabled = (enabled) => {
    postMessageToReactNative('nestedScroll', { enabled });
};
